export default __webpack_public_path__ + "static/media/all-active.0ff3f14a.svg";